import {complete} from 'complete'
import {bindControls} from 'controls'
import {captions} from 'captions'
import {setViewportDimensions} from 'utils'

function init() {

  // set viewport dimensions
  setViewportDimensions()
  window.addEventListener('resize', setViewportDimensions)

  // prevent viewport zoom
  var lastTouchEnd = 0
  document.addEventListener('touchend', function (event) {
    var now = (new Date()).getTime()
    if (now - lastTouchEnd <= 300) {
      event.preventDefault()
    }
    lastTouchEnd = now
  }, false)
  document.addEventListener('touchmove', function (event) {
    if (event.scale !== 1) { event.preventDefault() }
  }, false)

  bindControls()
  captions('')
  complete('init')
}

export {init}
